import get from 'lodash/get';

import { IStoreWithAppState, IAppState, ISpecialOffers } from './types';

export const getAppState = (state: IStoreWithAppState): IAppState => state.app;

export const getAppConfig = (state: IStoreWithAppState) => state.app.config;

export const getIsCryptoCrm = (state: IStoreWithAppState): boolean =>
  state.app.config?.isCryptoCrm || false;

export const getPageSizeOptions = (state: IStoreWithAppState): number[] =>
  state.app.config?.gridRowsNumber || [25, 50, 100];

export const getPlatformBaseCurrency = (state: IStoreWithAppState): string =>
  state.app.config?.platformBaseCurrency || '';

export const getTwoFaState = (state: IStoreWithAppState): string =>
  state.app.config?.twoFaType || 'none';

export const getSpecialOffers = (state: IStoreWithAppState): ISpecialOffers =>
  get(state, ['app', 'config', 'specialOffers'], {});
